<template>
  <div class="player share" :class="{'show': show}">
    <div class="container">
      <i class="icon-close-1 player-close" @click="playerClose"></i>
      <!-- 图片区域 -->
      <div class="image-area">
        <div class="image-swiper" ref="imageBox" id="imageBox" v-scroll="zoom">
          <swiper :options="swiperOption" ref="mySwiper" @transitionEnd="imageTransitionEnd">
            <swiper-slide v-for="image in images" :key="image.id">
              <div class="image-wrapper">
                <img v-bind:src="image.middleUrl" class="swiper-image" alt="" v-bind:style="{ transform:  'scale(' + image.imageScale + ')'}">
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <!-- 左右导航区域 -->
        <div class="swiper-nav left">
          <div class="nav-container" :class="{'grey': index <= 0}"  @click="navImage(-1)">
            <i class="icon-prev"></i>
          </div>
        </div>
        <div class="swiper-nav right">
          <div class="nav-container" :class="{'grey': index >= images.length - 1}" @click="navImage(1)">
            <i class="icon-next"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'sharePlayer',
  props: {
    images: Array,
    show: Boolean,
    allIndex: Number
  },
  components: {
    swiper,
    swiperSlide
  },
  created: function () {
  },
  data () {
    return {
      index: 0,
      swiperOption: {
        loop: false,
        preloadImages: false,
        on: {
        }
      },
      reloadData: false,
      playerTransition: false
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    showImage: function (index) {
      this.index = index
      this.reloadData = false
      this.swiper.slideTo(this.index, 0, false)
    },
    playerClose: function () {
      this.$emit('closeButtonClick')
    },
    cancelReload: function () {
      this.reloadData = false
    },
    imageTransitionEnd: function () {
      this.playerTransition = false
      if ((this.allIndex !== 0 && this.index === 1) || this.index === this.images.length - 2) {
        this.reloadData = true
        this.$emit('reloadPlayerData', this.index)
      }
    },
    zoom: function (event) {
      if (this.ocrProcess) return
      event = event || window.event
      if (event.preventDefault) {
        // Firefox
        event.preventDefault()
        event.stopPropagation()
      } else {
        // IE
        event.cancelBubble = true
        event.returnValue = false
      }
      var scale = this.images[this.index].imageScale
      scale = scale * Math.pow(1.01, event.deltaY)
      if (scale > 0.2 && scale < 4) {
        this.images[this.index].imageScale = scale
      }
    },
    navImage: function (offset) {
      if (this.reloadData || this.playerTransition) { return }
      var index = this.index
      index += offset
      if (index < 0) {
        index = 0
      }
      if (index >= this.images.length) {
        index = this.images.length - 1
      }
      if (index !== this.index) {
        this.index = index
        this.playerTransition = true
        this.swiper.slideTo(this.index, 600, false)
        // this.$viewer.view(this.index)
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
_toolbar-height = 104px
.player
  position fixed
  display none
  width 100%
  height 100%
  top 0px
  left 0px
  z-index 999
  &.show
    display block
  &.share
    .container
      position relative
      display block
      width 100%
      height 100%
      background-color rgba(0,0,0,0.4)
      padding-bottom _toolbar-height - 120px
      box-sizing border-box
      .player-close
        position absolute
        display block
        top 20px
        right 20px
        color #FFFFFF
        font-size 28px
        cursor pointer
        z-index 1002
      .image-area
        position relative
        display flex
        flex-direction column
        justify-content center
        align-items center
        width 100%
        height 100%
        padding 40px 60px 40px
        box-sizing border-box
        .image-swiper
          position relative
          display block
          width 100%
          height 100%
          overflow hidden
        .swiper-nav
          position absolute
          display flex
          flex-direction column
          justify-content center
          align-items center
          width 60px
          height 100%
          top 0px
          .nav-container
            display flex
            width 100%
            height 70%
            flex-direction column
            justify-content center
            align-items center
            i
              color #FFFFFF
              font-size 48px
              cursor pointer
            &.grey
              i
                color rgba(255, 255, 255, 0.2)
                cursor default
          &.left
            left 0px
          &.right
            right 0px
.image-swiper
  .viewer
    width 100%
    height 100%
    img
      display none
.swiper-container
  display block
  width 100%
  height 100%
  .swiper-wrapper
    .swiper-slide
      display flex
      flex-direction column
      justify-content center
      align-items center
      padding 0 20px
      box-sizing border-box
      .image-wrapper
        display flex
        position relative
        width 100%
        height 100%
        overflow hidden
        flex-direction column
        justify-content center
        align-items center
        overflow hidden
        color #FFFFFF
        .swiper-image
          max-width 100%
          max-height 100%
          transition all 0.2s
</style>



// WEBPACK FOOTER //
// src/components/Notebook/ShareImagePlayer.vue